

export const inAppBrowserFunc = async (targetUrl, props) => {

    if(targetUrl == "#" || targetUrl == "##") {
        return;
    }

    window.open(targetUrl)
}